import PdfIcon from "@/assets/icons/pdf.png";

export { PdfIcon };
